import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import React, { useContext } from "react";
import { ProjectContext } from "../../contexts/ProjectContext";

export const DeleteElementDialog = (props) => {

  const { deleteElement } = useContext(ProjectContext);

  const handleConfirm = () => {
    deleteElement();
    props.handleClose();
    props.refreshLayout();
  }

  return (
    <div>
      <Dialog open={props.open} onClose={props.handleClose}>
        <DialogTitle>Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Do you really want to delete selected item?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose} variant="contained" color="primary" startIcon={<CancelIcon />}>Cancel</Button>
          <Button onClick={handleConfirm} variant="contained" color="error" startIcon={<DeleteIcon />}>Delete</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}


